const BriefcaseIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.03125 2.0625C4.89453 2.0625 4.8125 2.17188 4.8125 2.28125V3.375H9.1875V2.28125C9.1875 2.17188 9.07812 2.0625 8.96875 2.0625H5.03125ZM3.5 2.28125C3.5 1.46094 4.18359 0.75 5.03125 0.75H8.96875C9.78906 0.75 10.5 1.46094 10.5 2.28125V3.375H12.25C13.207 3.375 14 4.16797 14 5.125V7.75H8.75H5.25H0V5.125C0 4.16797 0.765625 3.375 1.75 3.375H3.5V2.28125ZM14 8.625V12.125C14 13.1094 13.207 13.875 12.25 13.875H1.75C0.765625 13.875 0 13.1094 0 12.125V8.625H5.25V9.5C5.25 9.99219 5.63281 10.375 6.125 10.375H7.875C8.33984 10.375 8.75 9.99219 8.75 9.5V8.625H14Z"
      fill="#353535"
    ></path>
  </svg>
);

export default BriefcaseIcon;

